<div class="page-header ">
  <div class="flex xl:align-items-center flex-wrap xl:flex-nowrap gap-3">
    <div class="flex-grow-1">
      <app-primeng-breadcrumb></app-primeng-breadcrumb>
    </div>
    <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-content-end"></div>
  </div>

</div>
<div class="page-content mt-2">
  <p-stepper [(value)]="activeStep" [linear]="false">
    <p-step-list>
      <p-step [value]="0" class="flex-auto">
        <ng-template #content let-value="value" let-activateCallback="activateCallback">
          <p-button [text]="activeStep>=1"
            (onClick)=" onToggleTab('info', onEditClick);activateCallback('info',onEditClick)">
            <i-tabler name="building" class="ti-regular ti-lg"></i-tabler>
            Organization Info
          </p-button>
        </ng-template>
      </p-step>

      <p-step [value]="1" class="flex-auto">
        <ng-template #content let-value="value" let-activateCallback="activateCallback">

          <p-button [text]="activeStep!=1" [disabled]="operation == 'new' && activeStep < 1"
            (onClick)=" onToggleTab('admin', onEditClick);activateCallback('admin',onEditClick)">
            <i-tabler name="user-plus" class="ti-regular ti-lg"></i-tabler>
            Add Admin
          </p-button>
        </ng-template>
      </p-step>

      <p-step [value]="2">
        <ng-template #content let-value="value" let-activateCallback="activateCallback">
          <p-button [text]="activeStep!=2" [disabled]="operation == 'new' && activeStep < 2"
            (onClick)=" onToggleTab('resources', onEditClick);activateCallback('resources',onEditClick)">
            <i-tabler name="layout-grid" class="ti-regular ti-lg"></i-tabler>
            Assign Resources
          </p-button>

        </ng-template>
      </p-step>
    </p-step-list>

    <p-step-panels>
      <p-step-panel [value]="0" ngSkipHydration>
        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
          <form class="content" [formGroup]="customerDetailsForm" (ngSubmit)="onFormSubmit(nextCallback)"
            autocomplete="off">
            <div class="grid">

              <div class="col-12 md:col-6 lg:col-4 form-group">
                <ng-container *ngIf="operation !== 'view'">
                  <ng-container *ngIf="loading; else nameTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #nameTemplate>
                    <div class="flex flex-column gap-1">
                      <label for="username">Name<span class="text-red-500">*</span></label>
                      <input pInputText id="username" aria-describedby="username-help" type="text" maxlength="25"
                        placeholder="Organization Name" formControlName="customerName" required />
                        <small class="text-red-500" *ngIf="f['customerName']?.errors?.['pattern']">*Organization name should not contain special characters</small>
                    </div>
                  </ng-template>
                </ng-container>
                <p-card class="card-border" *ngIf="operation === 'view'">
                  @if(loading){
                  <app-skeleton [id]="'label-input-items'"></app-skeleton>
                  } @else{
                  <label for="username">Name<span class="text-red-500">*</span></label>
                  <h3 class="m-0 font-medium">{{customerDetails.customerName}}</h3>
                  }
                </p-card>
              </div>

              <div class="col-12 md:col-6 lg:col-4 form-group">
                <ng-container *ngIf="operation !== 'view'">
                  <ng-container *ngIf="loading; else communicationmailTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #communicationmailTemplate>
                    <div class="flex flex-column gap-1">
                      <label for="">Communication Email Address<span class="text-red-500">*</span></label>
                      <input pInputText type="text" class="form-control" placeholder="Customer Email"
                        formControlName="email" (input)="validateEmail($event)" required maxlength="50" />
                      <small
                        *ngIf="customerDetailsForm.get('email')?.touched && !customerDetailsForm.get('email')?.value"
                        class="text-red-500"> Email Address is required.</small>
                      <small *ngIf="customerDetailsForm.get('email')?.value && !isEmailValid" class="text-red-500">
                        *Invalid
                        Email Format.</small>
                      <small class="text-red-500"
                        *ngIf="customerDetailsForm.get('email')?.hasError('forbiddenCharacters')">
                        Email should not
                        contain percentage (%), or plus (+).
                      </small>
                      <small class="text-red-500"
                        *ngIf="customerDetailsForm.get('email')?.hasError('leadingOrTrailingSpaces')">
                        Email should not contain leading or trailing spaces.
                      </small>
                      <small class="text-red-500"
                        *ngIf="customerDetailsForm.get('email')?.hasError('multipleSpecialCharacters')">
                        Email should not contain consecutive underscores (_) or hyphens (-).
                      </small>
                    </div>
                  </ng-template>
                </ng-container>
                <p-card class="card-border" *ngIf="operation === 'view'">
                  @if(loading){
                  <app-skeleton [id]="'label-input-items'"></app-skeleton>
                  } @else{
                  <label for="username">Communication Email Address<span class="text-red-500">*</span></label>
                  <h3 class="m-0 font-medium">{{customerDetails.email}}</h3>
                  }
                </p-card>
              </div>
              <div class="col-12 md:col-6 lg:col-4 form-group">
                <ng-container *ngIf="operation !== 'view'">
                  <ng-container *ngIf="loading; else PrimarycontactTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #PrimarycontactTemplate>
                    <ng-container *ngIf="customPhoneForm">
                      <div class="flex flex-column gap-1">
                        <label for="PrimaryContactNumber">Contact Number<span class="text-red-500">*</span></label>
                        <app-custom-phone-number [customPhoneForm]="customPhoneForm" [isCustomer]="true"
                          [requiredErrorMessage]="'Contact Number is required.'"
                          (countryChange)="onCountryChange($event)"></app-custom-phone-number>
                      </div>
                    </ng-container>
                  </ng-template>
                </ng-container>
                <p-card class="card-border" *ngIf="operation === 'view'">
                  @if(loading){
                  <app-skeleton [id]="'label-input-items'"></app-skeleton>
                  } @else{
                  <label for="">Contact Number<span class="text-red-500">*</span></label>
                  <h3 class="m-0 font-medium"> {{ customPhoneForm.get('country')?.value?.dial_code }}
                    {{customPhoneForm.get('phoneNumber')?.value}}</h3>
                  }
                </p-card>
              </div>
              <div class="col-12 md:col-6 lg:col-4 form-group">
                <ng-container *ngIf="operation !== 'view'">
                  <ng-container *ngIf="loading; else addressTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #addressTemplate>
                    <div class="flex flex-column gap-1">
                      <label for="">Communication Address</label>
                      <input pInputText type="text" class="form-control" placeholder="Communication Address"
                        formControlName="address" maxlength="100" (input)="onCommAddressChanged($event)" />
                      <ng-container
                        *ngIf="customerDetailsForm.get('address')?.invalid && (customerDetailsForm.get('address')?.dirty || customerDetailsForm.get('address')?.touched)">
                        <small *ngIf="customerDetailsForm.get('address')?.hasError('whitespace')" class="text-red-500">
                          No leading or trailing whitespace is allowed.
                        </small>
                      </ng-container>
                    </div>
                  </ng-template>
                </ng-container>

                <p-card class="card-border" *ngIf="operation === 'view'">
                  @if(loading){
                  <app-skeleton [id]="'label-input-items'"></app-skeleton>
                  } @else{
                  <label for="username">Communication Address</label>
                  <h3 class="m-0 font-medium">{{customerDetails.address
                    ||
                    '-'}}</h3>
                  }
                </p-card>
              </div>
              <div class="col-12 md:col-6 lg:col-4 form-group">
                <ng-container *ngIf="operation !== 'view'">
                  <ng-container *ngIf="loading; else billingaddressTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #billingaddressTemplate>
                    <div class="flex flex-column gap-1">
                      <label for="username">Billing Address</label>
                      <input pInputText type="text" class="form-control" placeholder="Billing Address"
                        formControlName="billingAddress" maxlength="100" (input)="onBillingAddressChanged($event)" />
                      <ng-container
                        *ngIf="customerDetailsForm.get('billingAddress')?.invalid && (customerDetailsForm.get('billingAddress')?.dirty || customerDetailsForm.get('billingAddress')?.touched)">
                        <small *ngIf="customerDetailsForm.get('billingAddress')?.hasError('whitespace')"
                          class="text-red-500">
                          No leading or trailing whitespace is allowed.
                        </small>
                      </ng-container>
                    </div>
                  </ng-template>
                </ng-container>
                <p-card class="card-border" *ngIf="operation === 'view'">
                  @if(loading){
                  <app-skeleton [id]="'label-input-items'"></app-skeleton>
                  } @else{
                  <label for="username">Billing Address</label>
                  <h3 class="m-0 font-medium">{{customerDetails.billingAddress || '-'}}</h3>
                  }
                </p-card>

                <div class="flex mt-4" *ngIf="operation !== 'view'">
                  @if(loading){
                  <div class="flex gap-2">
                    <app-skeleton id="form-fields" [size]="{width:'1.5rem',height:'1.5rem'}"></app-skeleton>
                    <app-skeleton id="form-fields" [size]="{width:'15rem'}"></app-skeleton>
                  </div>
                  } @else{
                  <div class="flex items-center gap-1">
                    <p-checkbox label="Communication & Billing Address is same"
                      name="Communication & Billing Address is same" value="Communication & Billing Address is same"
                      [disabled]="!customerDetailsForm.get('address')?.value" [(ngModel)]="billingAddressToggleFlag"
                      [ngModelOptions]="{standalone: true}" [binary]="true" (onChange)="billingAddressToggle()"
                      (keydown)="billingAddressToggle()" id="communicationBillingAddress" />
                    <label for="size_normal">Communication & Billing Address is same</label>
                  </div>
                  }
                </div>
              </div>
              <!-- <div class="col-12 md:col-6 lg:col-4 form-group">
                <ng-container *ngIf="operation !== 'view'">
                  <ng-container *ngIf="loading; else domainTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #domainTemplate>
                    <div class="flex flex-column gap-1">
                      <label for="domain">Domain</label>
                      <input pInputText id="domain" type="text" class="form-control" placeholder="Enter Domain"
                        formControlName="domain" />
                    </div>
                  </ng-template>
                </ng-container>
                <p-card class="card-border" *ngIf="operation === 'view'">
                  @if(loading){
                  <app-skeleton [id]="'label-input-items'"></app-skeleton>
                  } @else{
                  <label for="domain">Domain</label>
                  <h3 class="m-0">{{customerDetails.domain || '-'}}</h3>
                  }
                </p-card>
              </div> -->
            </div>

            <div class="flex justify-content-end gap-3 mt-4">
              @if(loading){
              @if(operation == 'view'){
              <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
              }@else{
              @for (i of [1,2]; track i) {
              <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
              }
              }
              } @else{
              <p-button label="Cancel" severity="secondary" (onClick)="navigateToCustomerList()" />
              <p-button type="submit" *ngIf="operation !== 'view'" [label]="operation === 'new' ? 'Continue' : 'Update'"
                [disabled]="!customerDetailsForm.valid || !isEmailValid  ||  !customPhoneForm.valid || loading">
              </p-button>
              }
            </div>

          </form>
        </ng-template>
      </p-step-panel>


      <p-step-panel [value]="1" ngSkipHydration>
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
          let-index="index">
          <div class="content">
            <app-add-customer-admin [loading]="loading" [customerId]="customerId"
              [customerName]="customerDetails.customerName" [operation]="operation"
              [customerDetails]="customerAdminInfo?.response[0]"
              (dataEmitter)="onToggleTab('resources', onEditClick)"></app-add-customer-admin>
          </div>
        </ng-template>
      </p-step-panel>


      <p-step-panel [value]="2" ngSkipHydration>
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">
          <p-iconField iconPosition="left">
            @if(loading){
            <app-skeleton id="form-fields" [size]="{width:'10rem',height:'2rem'}"></app-skeleton>
            }@else{
              <p-inputicon> <i-tabler name="search" class="it-normal ti-base"></i-tabler></p-inputicon>
            <input type="text" pInputText class="mb-2" [(ngModel)]="searchTerm" placeholder="Search Application" />
            }
          </p-iconField>
          @if(loading){
          <ng-container *ngTemplateOutlet="skeletonLoadingTemplate"></ng-container>
          } @else{
          <ng-container
            *ngIf="(applicationsList | searchFilter:searchTerm:'applicationName')?.length ?? 0 > 0; else noApplications">
            <div class="um-scroll-content">
                <div class="flex mb-3 border-1 border-200 bg-white border-round flex-column"
                  *ngFor="let application of applicationsList | searchFilter:searchTerm:'applicationName'; let index=index">
                  <div class="flex p-3 header flex-1">
                    <div class="flex align-items-center gap-2 flex-1">
                      <p-checkbox [disabled]="operation === 'view'"
                      [(ngModel)]="applicationSelectedStatusCopy[application.applicationName]"
                      (click)="toggleApplicationSelectedStatus(application.applicationName,application.applicationId)"
                      [id]="application.applicationName" [binary]="true" inputId="binary"
                      (keydown)="toggleApplicationSelectedStatus(application.applicationName,application.applicationId)" />
                    <label for="size_normal" class="flex-1">{{application.applicationName}}</label>
                    </div>
                  </div>
                  <div *ngIf="applicationSelectedStatus[application.applicationName] && appsListWithResources"
                  class="px-3 py-2 border-top-1 border-200">
                  <app-assign-resources [disabled]="operation === 'view'" (loadingResourceList)="getLoadingflag($event)"
                    [applicationId]="application.applicationId" [applicationListWithResources]="appsListWithResources"
                    [customerId]="customerId" [applicationName]="application.applicationName"
                    (getData)="getdata($event)">
                  </app-assign-resources>
                </div>
                </div>

              <!-- <p-card class="border-1 border-200 block card-bodyy-0" styleClass="mb-2"
                *ngFor="let application of applicationsList | searchFilter:searchTerm:'applicationName'; let index=index">
                @if(loading){
                <div class="flex gap-2">
                  <app-skeleton id="form-fields" [size]="{width:'1.5rem',height:'1.5rem'}"></app-skeleton>
                  <app-skeleton id="form-fields" [size]="{width:'5rem'}"></app-skeleton>
                </div>
                } @else{
                <ng-template pTemplate="header">
                  <div class="p-3">
                    <p-checkbox class="w-full" [disabled]="operation === 'view'"
                      [(ngModel)]="applicationSelectedStatusCopy[application.applicationName]"
                      (click)="toggleApplicationSelectedStatus(application.applicationName,application.applicationId)"
                      [id]="application.applicationName" [binary]="true" inputId="binary"
                      (keydown)="toggleApplicationSelectedStatus(application.applicationName,application.applicationId)" />
                    <label for="size_normal">{{application.applicationName}}</label>
                  </div>
                </ng-template>
                <div *ngIf="applicationSelectedStatus[application.applicationName] && appsListWithResources"
                  class="py-2">
                  <app-assign-resources [disabled]="operation === 'view'" (loadingResourceList)="getLoadingflag($event)"
                    [applicationId]="application.applicationId" [applicationListWithResources]="appsListWithResources"
                    [customerId]="customerId" [applicationName]="application.applicationName"
                    (getData)="getdata($event)">
                  </app-assign-resources>
                </div>
                }
              </p-card> -->
            </div>
            <div class="flex justify-content-end gap-3 mt-4">

              <p-button label="Cancel" severity="secondary" (onClick)="navigateToCustomerList()" />
              <p-button [disabled]= "isAddUpdateButtonClicked" [label]="operation ==
                'new'? 'Save': 'Update'" *ngIf="operation !== 'view'" (onClick)="assignOrUpdateResources()" />
            </div>
          </ng-container>
          }
        </ng-template>
        <ng-template #noApplications>
          @if(applicationListLoading){
          <ng-container *ngTemplateOutlet="skeletonLoadingTemplate"></ng-container>
          } @else {
          <div class="flex text-center text-lg text-500 p-3 lg:p-4 justify-content-center">No Applications to display
          </div>
          }
        </ng-template>
        <ng-template #skeletonLoadingTemplate>
          <div class="um-scroll-content">
            @for(i of [1,2,3,4,5,6,7,8,9,10];track i){
            <p-card class="card-border block card-bodyy-0" styleClass="mb-2">
              <div class="flex gap-2 p-2">
                <app-skeleton [id]="'form-fields'" [size]="{width:'1.5rem',height:'1.5rem'}"></app-skeleton>
                <app-skeleton [id]="'form-fields'" [size]="{width:'20rem',height:'1.5rem'}"></app-skeleton>
              </div>
            </p-card>
            }
          </div>
          <div class="flex justify-content-end gap-3 mt-4">
            @if(applicationListLoading){
            @if(operation == 'view'){
            <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
            }
            } @else{
            @for (i of [1,2]; track i){
            <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
            }
            }
          </div>
        </ng-template>
      </p-step-panel>



    </p-step-panels>
  </p-stepper>

</div>


<p-toast />

<style>
.error-message {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  line-height: 1rem;
}
.error-message small {
  display: block;
  margin-bottom: 0.25rem;
}
</style>